/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'

const getAllOrg = param => {
  return axiosInstance.post(`/api/gcuser/v1/organization/getAll`, param).then(res => res.data)
}
export {
    getAllOrg
}